import { Price, PriceHistory, PriceType } from 'src/types';

export type GAPriceType = PriceType | '';

export interface GAPrice {
  type: GAPriceType;
  price?: number | undefined | null;
}

export type GAOfferStatus = 'international' | 'variant' | 'raw' | '';

export enum ProductActionType {
  PRODUCT_RECEIVE = 'PRODUCT_RECEIVE',
  PRODUCT_FETCH_ERROR = 'PRODUCT_FETCH_ERROR',
  PRODUCT_RATE_REQUEST = 'PRODUCT_RATE_REQUEST',
  PRODUCT_REVIEW_FAILED = 'PRODUCT_REVIEW_FAILED',
  PRODUCT_PRICE_CLICK = 'PRODUCT_PRICE_CLICK',
  PRODUCT_NAVIGATION = 'PRODUCT_NAVIGATION',
  PRODUCT_PRICE_CLICK_BOUNCE = 'PRODUCT_PRICE_CLICK_BOUNCE',
  PRODUCT_HEADER_CLICK = 'PRODUCT_HEADER_CLICK',
  PRODUCT_CONDITION_SELECTED = 'PRODUCT_CONDITION_SELECTED',
  CAMPAIGNS_RECEIVE = 'CAMPAIGNS_RECEIVE',
  ROUTE_LOADED = 'ROUTE_LOADED',
}

export type ProductPriceClickStatus = GAOfferStatus | undefined;

export type ProductHeaderClickEventType =
  | 'list-add'
  | 'alert-remove'
  | 'alert-create'
  | 'rank-category'
  | 'price-history';

export type ProductPriceClickPrice = Price | GAPrice | null | undefined;
export interface ProductPriceClickFuncResult {
  type: ProductActionType;
  productId: number | null;
  price: ProductPriceClickPrice;
  featured: 'Featured' | 'Not Featured';
  status: ProductPriceClickStatus;
  isAlternative?: boolean | undefined;
  context: string | undefined;
}

export type ProductPriceClickFunc = (
  productId: number | null,
  price: Price | PriceHistory | number | undefined | null,
  featured: boolean,
  status: ProductPriceClickStatus,
  isAlternative?: boolean | undefined,
  context?: string // Means to represent in which context the click was made
) => ProductPriceClickFuncResult;
